var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mb-3 overflow-x-auto overflow-y-hidden steps-scroll-wrapper"},[_c('div',{staticClass:"flex items-start justify-between relative min-w-[580px] md:min-w-0 pb-1"},_vm._l((_vm.processedSteps),function(item,index){return _c('div',{key:index,class:[
        'relative flex flex-col',
        index < _vm.processedSteps.length - 1 ? 'flex-1' : 'flex-none'
      ]},[(index < _vm.processedSteps.length - 1)?_c('div',{staticClass:"absolute top-3 left-6 right-0 h-[1.5px] bg-[#E2E8F0] z-0"}):_vm._e(),_c('div',{staticClass:"relative z-10 flex flex-col items-start pr-2"},[_c('div',{class:[
            'h-6 w-6 rounded-full flex items-center justify-center text-xs font-semibold select-none transition-colors duration-200',
            item.current
              ? 'bg-primary text-white shadow-sm'
              : item.done
                ? 'bg-primary text-white'
                : 'bg-[#737373] text-white'
          ]},[(item.done)?_c('b-icon',{staticClass:"text-white",attrs:{"icon":"check","scale":"1.2"}}):_c('span',[_vm._v(_vm._s(item.number))])],1),_c('div',{class:[
            'mt-1 text-xs md:text-sm whitespace-nowrap transition-colors duration-200',
            item.current
              ? 'text-primary font-semibold'
              : item.done
                ? 'text-[#333333] font-medium'
                : 'text-[#737373]'
          ]},[_vm._v(" "+_vm._s(item.name)+" ")])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }